export default {
    namespaced: true,
    state: () => ({
            step1inviato : false,
            step2inviato : false,
            step3inviato : false,
            step4inviato : false,
            step5inviato : false,
            step6inviato : false,
            step7inviato : false,
            step8inviato : false,
            step9inviato : false,
            step10inviato : false,
            conclusione : false,
    }),
    getters:{
        getStatoInvio1:(state)=>{
            return state.step1inviato;
        },
        getStatoInvio2:(state)=>{
            return state.step2inviato;
        },
        getStatoInvio3:(state)=>{
            return state.step3inviato;
        },
        getStatoInvio4:(state)=>{
            return state.step4inviato;
        },
        getStatoInvio5:(state)=>{
            return state.step5inviato;
        },
        getStatoInvio6:(state)=>{
            return state.step6inviato;
        },
        getStatoInvio7:(state)=>{
            return state.step7inviato;
        },
        getStatoInvio8:(state)=>{
            return state.step8inviato;
        },
        getStatoInvio9:(state)=>{
            return state.step9inviato;
        },
        getStatoInvio10:(state)=>{
            return state.step10inviato;
        },
        getStatoInvioConclusione:(state)=>{
            return state.conclusione;
        },

    },
    actions: {
        commitPulisciStato:(context)=>{
            context.commit('pulisciStato');
        },
        commitSetStatoInvio1: (context, value) => {
            context.commit('setStatoInvio1', value);
        },
        commitSetStatoInvio2: (context, value) => {
            context.commit('setStatoInvio2', value);
        },
        commitSetStatoInvio3: (context, value) => {
            context.commit('setStatoInvio3', value);
        },
        commitSetStatoInvio4: (context, value) => {
            context.commit('setStatoInvio4', value);
        },
        commitSetStatoInvio5: (context, value) => {
            context.commit('setStatoInvio5', value);
        },
        commitSetStatoInvio6: (context, value) => {
            context.commit('setStatoInvio6', value);
        },
        commitSetStatoInvio7: (context, value) => {
            context.commit('setStatoInvio7', value);
        },
        commitSetStatoInvio8: (context, value) => {
            context.commit('setStatoInvio8', value);
        },
        commitSetStatoInvio9: (context, value) => {
            context.commit('setStatoInvio9', value);
        },
        commitSetStatoInvio10: (context, value) => {
            context.commit('setStatoInvio10', value);
        },
        commitSetStatoInvioConclusione: (context, value) => {
            context.commit('setStatoInvioConclusione', value);
        },
    },
    mutations: {
        setStatoInvio1: (state, value) => {
            state.step1inviato = value;
        },
        setStatoInvio2: (state, value) => {
            state.step2inviato = value;
        },
        setStatoInvio3: (state, value) => {
            state.step3inviato = value;
        },
        setStatoInvio4: (state, value) => {
            state.step4inviato = value;
        },
        setStatoInvio5: (state, value) => {
            state.step5inviato = value;
        },
        setStatoInvio6: (state, value) => {
            state.step6inviato = value;
        },
        setStatoInvio7: (state, value) => {
            state.step7inviato = value;
        },
        setStatoInvio8: (state, value) => {
            state.step8inviato = value;
        },
        setStatoInvio9: (state, value) => {
            state.step9inviato = value;
        },
        setStatoInvio10: (state, value) => {
            state.step10inviato = value;
        },
        setStatoInvioConclusione: (state, value) => {
            state.conclusione = value;
        },
        pulisciStato:(state)=>{
                state.step1inviato = false;
                state.step2inviato = false;
                state.step3inviato = false;
                state.step4inviato = false;
                state.step5inviato = false;
                state.step6inviato = false;
                state.step7inviato = false;
                state.step8inviato = false;
                state.step9inviato = false;
                state.step10inviato = false;
                state.conclusione = false;
        }
    },
}